import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--textarea-counter"
//
// Keeps Ui::TextareaComponent's "<n> / <maxlength>" counter in step with the
// textarea; the server only renders the initial length.
export default class extends Controller {
  static targets = ["current"]

  connect() {
    this.update()
  }

  update() {
    const textarea = this.element.querySelector("textarea")
    if (!textarea || !this.hasCurrentTarget) return

    const length = textarea.value.length
    this.currentTarget.textContent = length
    this.currentTarget.dataset.current = length
  }
}
